import { render, staticRenderFns } from "./updateStroke.vue?vue&type=template&id=48cf2af0&scoped=true&"
import script from "./updateStroke.vue?vue&type=script&lang=js&"
export * from "./updateStroke.vue?vue&type=script&lang=js&"
import style0 from "./updateStroke.vue?vue&type=style&index=0&id=48cf2af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf2af0",
  null
  
)

export default component.exports